module.exports = __webpack_public_path__ + "static/media/peshawar.1b644e49.svg";